export default __webpack_public_path__ + "static/media/favicon.700e0b2d.ico";